import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Link } from 'react-router-dom';
import { Box } from '@mui/material';

const TableDebtComponent = ({ columns, results }) => {

  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <TableContainer component={Box} style={{ width: '70%' }}>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.field}
                  style={{
                    backgroundColor: '#f2f2f2',
                    color: '#333',
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }}
                >
                  {column.headerName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {results.map((row) => (
              <TableRow key={row.id}>
                {columns.map((column) => (
                  <TableCell key={column.field} style={{ textAlign: 'center' }}>
                    {column.field === 'registryUrl'
                      ? (
                        <Link to={row[column.field]} target='_blank'>
                          {row[column.field].split('/')[5]}
                        </Link>
                      )
                      : column.enum
                        ? (
                          column.enum[row[column.field]]
                        )
                        : (
                          row[column.field]
                        )}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default TableDebtComponent;
